import { find, get } from "lodash";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import { getPhonePrefix } from "./values";

export const conversionTransactionId = (projectId, event) =>
  `${projectId}-${event}`;

export const sendEnhancedConversion = (
  project,
  conversionId,
  transactionId,
) => {
  const phone = get(
    find(get(project, "contact.telecoms", []), {
      system: CONTACT_POINT_SYSTEM.PHONE,
    }),
    "value",
    " ",
  );
  const prefix = getPhonePrefix(phone);
  const email = get(
    find(get(project, "contact.telecoms", []), {
      system: CONTACT_POINT_SYSTEM.EMAIL,
    }),
    "value",
    " ",
  );
  const postal_code = get(
    find(get(project, "contact.telecoms", []), {
      system: CONTACT_POINT_SYSTEM.ZIP_CODE,
    }),
    "value",
    " ",
  );
  const city = get(
    find(get(project, "contact.telecoms", []), {
      system: CONTACT_POINT_SYSTEM.CITY,
    }),
    "value",
    " ",
  );
  const street = get(
    find(get(project, "contact.telecoms", []), {
      system: CONTACT_POINT_SYSTEM.ADDRESS,
    }),
    "value",
    " ",
  );
  const userData = {
    email,
    phone_number: `${prefix}${phone.replace(/\s+/g, "").slice(-9)}`,
    first_name: get(project, "contact.user.firstname"),
    last_name: get(project, "contact.user.lastname"),
    address: { street, city, postal_code },
  };
  if (window.gtag) {
    window.gtag("set", "user_data", userData);
    window.gtag("event", "conversion", {
      send_to: conversionId,
      ...(transactionId && { transaction_id: transactionId }),
    });
  }
};
